import home from './verifiers/home';
import evaluations from './verifiers/performances';

export default [
    ...home,
    ...evaluations
];